export default __webpack_public_path__ + "static/media/BienesRaices.b245af00.png";